module.exports = __webpack_public_path__ + "static/media/parking.f91d905a.svg";